import { pathgen } from 'object-path-generator';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
export const useDeleteProposalTestIds = pathgen('useDeleteProposalTestIds');
export const useDeleteProposal = function useDeleteProposal() {
    let { onSuccess, biCode } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { mutate, isLoading } = useMutationState({
        mutationFn: (id)=>api.relationship.cancelProposal(id),
        toasts: {
            successMessage: 'Proposal withdrawn and deleted successfully.',
            successTestId: useDeleteProposalTestIds.SuccessToast(),
            errorMessage: 'Failed to withdraw and delete proposal',
            errorTestId: useDeleteProposalTestIds.ErrorToast()
        },
        biCode,
        onSuccess
    });
    return {
        deleteProposal: mutate,
        isLoading
    };
};
